import React, { useState } from "react";
import { Button, CheckboxField } from "../../../helpers";


const ApproveVendorPaymentModal = (props) => {
    const { handleApproveVendorPayment } = props
    const [isAlreadyIncludedProfit, setIsAlreadyIncludedProfit] = useState(false)

    const handleApprove = () => {
        handleApproveVendorPayment(isAlreadyIncludedProfit)
    }

    return(
        <div className="vp-approve-modal flex flex-column">
            <h5>Vendor Payment No</h5>
            <div className="flex flex-row mb-2" >
                <CheckboxField inputId="checkinId" checked={isAlreadyIncludedProfit} label="Already Used in Profit Calculation" onChange={() => setIsAlreadyIncludedProfit(!isAlreadyIncludedProfit)} />
            </div>
            <div className="flex flex-row justify-content-end">
                <Button icon="" className="small-btn" label="Approve" onClick={() => handleApprove()}/>
            </div>
        </div>
    )
}

export default ApproveVendorPaymentModal